module.exports = __webpack_public_path__ + "static/assets/48a24f8755175f5c5cb95a7466afae1d.svg";